// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CorsoInfo_wrap__t4W2l"};